import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

async function fetchInfos (cityId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'useful-infos')
    const response = await axios.get(url)

    return response.data
}

async function updateInfos (infos, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'useful-infos')
    const response = await axios.patch(url, infos, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function createInfo (info, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'useful-infos')
    const response = await axios.post(url, info, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function deleteInfo (infoId, cityId, token)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'useful-infos', infoId.toString())
    const response = await axios.delete(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

export default { fetchInfos, updateInfos, createInfo, deleteInfo }


// WEBPACK FOOTER //
// ./src/services/usefulInfo.js